import moment from 'moment';

export const getNextTask = (tasks) => {
  if (!tasks || !Array.isArray(tasks) || tasks.length === 0) {
    return null;
  }

  var now = moment();
  var upcoming = null;
  var mostRecent = null;

  tasks.forEach(function(task) {
    var due = moment(task.due_at);
    // Find earliest upcoming task (today or future)
    if (due.isSameOrAfter(now, 'day')) {
      if (!upcoming || due.isBefore(moment(upcoming.due_at))) {
        upcoming = task;
      }
    }
    // Track most recent overdue as fallback
    if (!mostRecent || due.isAfter(moment(mostRecent.due_at))) {
      mostRecent = task;
    }
  });

  return upcoming || mostRecent;
};
